// extracted by mini-css-extract-plugin
module.exports = {"desktopOnly":"_2ZmO-","mobileOnly":"_1l-p3"};